module.exports = __webpack_public_path__ + "resources/img/img_security_chakramax_sac_en.ca2911e2edfa3e4aa50e3cd1df03c0a7.png";